export default __webpack_public_path__ + "static/media/vitrendz-logo-new.830e46e4.svg";